module.exports = __webpack_public_path__ + "img/failure-toast-icon.ef448617.svg";